export const ADMIN_PORTAL_LOGS_TABLE_HEADERS = [
    { label: 'PORTAL USER LOGS', colspan: 5 },
];

export const ADMIN_PORTAL_LOGS_TABLE_SUB_HEADERS = [
    { label: 'DATE TAKEN', key: 'dateTaken', sortable: false},
    { label: 'PORTAL TAB', key: 'portalTab', sortable: false },
    { label: 'ACTION MADE', key: 'actionMade', sortable: false },
    { label: 'ACCOUNT TAKEN BY', key: 'actionTakenBy', sortable: false },
    { label: 'USERNAME', key: 'username', sortable: false },
];

export const PORTAL_ACCOUNT_TABLE_SUB_HEADERS = [
    { label: 'USERNAME',     key: 'username',     sortable: true,  centered: false },
    { label: 'FULL NAME',    key: 'fullName',     sortable: true,  centered: false },
    { label: 'EMAIL',        key: 'email',        sortable: true,  centered: false },
    { label: 'ACCOUNT TYPE', key: 'accountType',  sortable: true,  centered: false  },
    { label: 'DATE CREATED', key: 'dateCreated',  sortable: true,  centered: true  },
    { label: 'LAST LOGIN',     sortable: false, centered: true  },
    { label: 'MODIFIED DATE',  sortable: false, centered: true  },
    { label: 'MODIFIED BY',    sortable: false, centered: true  },
    { label: 'STATUS',         sortable: false, centered: true  },
    { label: 'ACTION',         sortable: false, centered: true  },
];
